import { Link } from "react-router-dom";
import { Arrow } from "@/components/site/parts";
import { useCopy } from "@/lib/copy";

export default function NotFound() {
  const t = useCopy();
  return (
    <section className="bx" style={{ paddingTop: 16 }}>
      <div className="ph rise d1 padl split">
        <div style={{ display: "flex", flexDirection: "column", gap: 22 }}>
          <span className="mono" style={{ fontSize: 12, color: "#FF3D3D", textTransform: "uppercase" }}>{t("404.kicker")}</span>
          <h1 className="ph-h stretch" style={{ animationDelay: ".2s" }}>
            {t("404.title")} <span className="em-y">{t("404.accent")}</span>
          </h1>
          <p className="ph-sub">{t("404.body")}</p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 10 }}>
            <Link to="/" className="btn btn-y" style={{ height: 52, borderRadius: 14 }}>{t("404.cta")} <Arrow /></Link>
            <Link to="/projects" className="btn" style={{ height: 52, borderRadius: 14, border: "2px solid #4A4F5A", color: "#fff", background: "transparent" }}>{t("nav.projects")}</Link>
          </div>
        </div>
        <svg role="img" aria-label="A car that has spun out, with skid marks and smoke" viewBox="0 0 420 300" style={{ width: "100%", maxWidth: 480, justifySelf: "center", height: "auto" }}>
          <path d="M0 260 C120 250 200 220 260 150" fill="none" stroke="#3A3F4B" strokeWidth="56" strokeLinecap="round" />
          <path className="skid" d="M20 250 C120 240 190 215 240 160" fill="none" stroke="#0B0C0F" strokeWidth="5" strokeLinecap="round" />
          <path className="skid" d="M30 268 C130 258 205 230 258 172" fill="none" stroke="#0B0C0F" strokeWidth="5" strokeLinecap="round" style={{ animationDelay: ".15s" }} />
          <rect x="300" y="40" width="22" height="200" rx="3" fill="#F3F0E8" />
          <g fill="#FF3D3D">{[40, 80, 120, 160, 200].map((y) => <rect key={y} x="300" y={y} width="22" height="20" />)}</g>
          <circle className="smoke" cx="230" cy="150" r="16" fill="#6E7380" />
          <circle className="smoke" cx="245" cy="140" r="12" fill="#6E7380" style={{ animationDelay: ".8s" }} />
          <circle className="smoke" cx="220" cy="160" r="10" fill="#6E7380" style={{ animationDelay: "1.6s" }} />
          <g transform="translate(262 140)">
            <g className="spinout">
              <rect x="-22" y="-17" width="12" height="7" rx="2" fill="#0B0C0F" />
              <rect x="-22" y="10" width="12" height="7" rx="2" fill="#0B0C0F" />
              <rect x="10" y="-17" width="12" height="7" rx="2" fill="#0B0C0F" />
              <rect x="10" y="10" width="12" height="7" rx="2" fill="#0B0C0F" />
              <rect x="-25" y="-11" width="50" height="22" rx="8" style={{ fill: "var(--blue)" }} />
              <rect x="-25" y="-3" width="50" height="6" fill="#FFC83D" />
              <rect x="-4" y="-8" width="15" height="16" rx="5" fill="#15171C" />
            </g>
          </g>
        </svg>
      </div>
    </section>
  );
}
